export default "__VITE_ASSET__L6ULre43UVKB_8BlqbEXWQ__";